<template>
    <ion-app>
        <ion-vue-router></ion-vue-router>
    </ion-app>
</template>

<script>
    import { notifications } from "./notifications";

    export default {
        name: 'app',
        data() {
            return {
                user: {},
            }
        },
        methods: {
            nextStep: function() {
                //AmplifyEventBus.$emit('nextStep');
                //this.$logger.debug(this.$refs);
                //this.$refs.child1.nextStep();
            },
        },
        created() {
            this.$AmplifyEventBus.$on('authState', info => {
                if (info === 'signedIn') {
                    this.$logger.debug('detected signedIn');
                    this.$store.setSignedIn(true);
                    //this.signedIn = true;
                    this.$Amplify.Auth.currentAuthenticatedUser().then(user => {
                        this.$store.setUser(user);
                        if(notifications.isMessagingSupported()) {
                            notifications.setAuthToken(user.signInUserSession.getIdToken().getJwtToken());
                            notifications.getMessagingToken();
                        }
                        this.$router.push('/');
                    }).catch(() => {
                        this.signedIn = false
                    });
                } else if (info === 'signedOut') {
                    this.$logger.debug('detected signedOut');
                    this.$store.setSignedIn(false);
                    // if we're not in main, go back there
                    if(this.$route.name != 'main') {
                        this.$router.push({name: 'main'})
                    }
                    this.$store.setUser({});
                    //this.$router.push('/splash')
                }
            });
            this.$AmplifyEventBus.$on('requestNotifications', () => {
                if(notifications.isMessagingSupported()) {
                    notifications.requestNotificationPermission();
                }
            });
            this.$Amplify.Auth.currentAuthenticatedUser()
                .then(user => {
                    this.$store.setSignedIn(true)
                    //this.signedIn = true;
                    this.$logger.debug('token', user.signInUserSession.getIdToken().getJwtToken());
                    if(notifications.isMessagingSupported()) {
                        notifications.setAuthToken(user.signInUserSession.getIdToken().getJwtToken());
                    }
                    //this.$logger.debug('authToken', authToken);
                    this.user = user;
                    this.$logger.debug('signed in');
                    this.$store.setUser(user);
                    if(notifications.isMessagingSupported()) {
                        notifications.getMessagingToken();
                    }
                })
                .catch(() => {
                    this.$logger.debug('not signed in');
                    this.$store.setSignedIn(false)
                    //this.$router.push({name: 'welcome'});
                });
        }
    }
</script>

<style>
    @import url('https://fonts.googleapis.com/css?family=Nunito:400,600&display=swap');

    :root {
        --ion-color-primary: #ff0055 !important;
        --ion-color-primary-rgb: 255,0,85 !important;
        --ion-color-primary-contrast: #ffffff !important;
        --ion-color-primary-contrast-rgb: 255,255,255 !important;
        --ion-color-primary-shade: #e0004b !important;
        --ion-color-primary-tint: #ff1a66 !important;
    }

    html {
        background-color: #fff;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    ion-content {
        --background: unset;
    }

    ion-card-header {
        background: none;
    }

    ion-card-title {
        font-size: 2.2em;
        font-weight: bold;
        --color: var(--ion-color-primary);
    }

    .ion-page {
        max-height: 100em;
    }

    .content-row {
        min-height: 100%;
    }

    .content-row .logo {
        height: 4em;
        max-width: 11.5em;
        margin: 0 auto 1em auto;
    }

    .divider {
        display: block;
        width: 50%;
        margin: .7em auto;
        text-align: center;
        color: #999;
    }

    .divider:before, .divider:after {
        content: "";
        display: inline-block;
        width: 50%;
        margin: 0 .5em 0 -55%;
        vertical-align: middle;
        border-bottom: 1px solid #aaa;
    }

    .divider:after {
        margin: 0 -55% 0 .5em;
    }

    .collapse-fade-leave-active, .collapse-fade-enter-active {
        transition: all .5s ease-in-out;
        max-height: 20em;
        opacity: 1;
    }

    .collapse-fade-enter, .collapse-fade-leave-to {
        max-height: 0;
        /*transform: translateX(10px);*/
        opacity: 0;
    }

    .collapse-leave-active {
        /*max-height: 100em;*/
        max-height: 100vh;
        transition: all 2s cubic-bezier(0, 1, 0, 1);
        -webkit-transition: all 2s cubic-bezier(0, 1, 0, 1);
    }

    .collapse-enter-active {
        /*max-height: 100em;*/
        max-height: 100vh;
        transition: all 1s cubic-bezier(0, 1, .5, 1);
        -webkit-transition: all 1s cubic-bezier(0, 1, .5, 1);
    }

    .collapse-enter, .collapse-leave-to {
        max-height: 0;
    }

    .accordion-enter-active {
        transition: max-height .5s ease-in;
        -webkit-transition: max-height .5s ease-in;
        overflow: hidden;
        max-height: 100vh;
    }

    .accordion-leave-active {
        transition: max-height .5s ease-in;
        -webkit-transition: max-height .5s ease-in;
        overflow: hidden;
    }

    .accordion-enter {
        max-height: 0;
    }

    .flex-enter-active, .flex-leave-active {
        transition: flex 2s linear;
        flex: 1;
    }
    .flex-enter, .flex-leave-to /* .fade-leave-active below version 2.1.8 */ {
        flex: 0;
    }

    .swipe-right-enter-active,
    .swipe-right-leave-active {
        transition: transform .5s ease-in-out;
    }
    .swipe-right-enter {
        transform: translateX(110%);
    }
    .swipe-right-enter-to, .swipe-right-leave  {
        transform: translateX(0%);
    }
    .swipe-right-leave-to {
        transform: translateX(-110%);
    }

    .swipe-left-enter-active,
    .swipe-left-leave-active {
        transition: transform .5s ease-in-out;
    }
    .swipe-left-enter {
        transform: translateX(-110%);
    }
    .swipe-left-enter-to, .swipe-left-leave {
        transform: translateX(0%);
    }
    .swipe-left-leave-to {
        transform: translateX(110%);
    }
</style>
